import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';
import { UtilsService } from '../../services/utils/utils.service';

@Component({
  selector: 'gdp-copy-feedback-popup',
  templateUrl: './copy-feedback-popup.component.html',
  styleUrls: ['./copy-feedback-popup.component.scss']
})
export class CopyFeedbackPopupComponent implements OnInit {
  @Input() title: string;
  @Input() content: any;
  @Input() feedback: string;

  constructor(
    private modalService: NgbModal,
    private notificationService: NotificationService,
    private utilsService: UtilsService
  ) { }

  ngOnInit() {}

  public close() {
    this.modalService.dismissAll();
  }

  public copy() {
    const content = typeof this.content === 'object' && this.content !== null
      ? JSON.stringify(this.content)
      : this.content;

    this.utilsService.copyToClipboard(
      content,
      'text/plain',
      () => {  this.notificationService.success(this.feedback);}
    );
  }

}
